const words = [
  "Cafe food",
  "Sweet delights",
  "Burgers",
  "Sunday Roast",
  "Good food, great company",
];

export default function Marquee() {
  return (
    <section
      aria-hidden="true"
      data-testid="marquee"
      className="overflow-hidden border-y border-line/70 bg-ink2/70 py-7"
    >
      <div className="flex w-max animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {words.map((w) => (
              <span key={w} className="flex items-center">
                <span className="whitespace-nowrap px-8 font-serif text-2xl italic text-sage/90 md:text-4xl">
                  {w}
                </span>
                <span className="h-1.5 w-1.5 rotate-45 bg-sage/40" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
